export default {
  beforeMount() {
    this.$i18n.locale =
      process.env.NODE_ENV === "production"
        ? drupalSettings.path.currentLanguage
        : "en";
  },
  methods: {
    /**
     * Get string value from locale file/configuration.
     *
     * @param {string} args arguments
     * @return {any} any
     */
    locale(args) {
      // Default to using i18n vue plugin if not in production
      if (process.env.NODE_ENV !== "production") {
        return this.$t(args);
      }
      // Otherwise, if in production try to grab string from Drupal
      const keys = args.split(".");
      let obj =
        drupalSettings[process.env.VUE_APP_NAME].locale[
          drupalSettings.path.currentLanguage
        ][keys[0]];
      // Traverse through keys until we hit the end and grab the value
      for (let i = 1; i < keys.length; i++) {
        obj = obj[keys[i]];
      }
      return obj;
    },
    /**
     * Return an array of objects from locale file/configuration.
     * Use regular locale function if it's an array of values.
     *
     * @param {string} args arguments
     * @return {any[]} any
     */
    localeObjectArray(args) {
      const value = this.locale(args);
      return Object.values(value);
    }
  }
};
